import { render, staticRenderFns } from "./zoneSettings.vue?vue&type=template&id=f0d2ff9e&scoped=true&"
import script from "./zoneSettings.vue?vue&type=script&lang=js&"
export * from "./zoneSettings.vue?vue&type=script&lang=js&"
import style0 from "./zoneSettings.vue?vue&type=style&index=0&id=f0d2ff9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d2ff9e",
  null
  
)

export default component.exports